import { render, staticRenderFns } from "./WTopMenu.vue?vue&type=template&id=46860771"
import script from "./WTopMenu.vue?vue&type=script&lang=js"
export * from "./WTopMenu.vue?vue&type=script&lang=js"
import style0 from "./WTopMenu.vue?vue&type=style&index=0&id=46860771&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports